import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { updatePersona } from '../../services/apiService';
import { PACING_OPTIONS, HUMOR_OPTIONS } from '../../content/personaOptions';
import styles from './CommunicationStyleModal.module.css';

const CommunicationStyleModal = ({ digitalLegacy, onClose, onSave }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [communicationStyle, setCommunicationStyle] = useState(
    digitalLegacy.communicationStyle || { pacing: [], humorStyle: [] }
  );
  const [isSaving, setIsSaving] = useState(false);

  const handleCheckboxChange = (field, value) => {
    const currentValues = communicationStyle[field] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter((item) => item !== value)
      : [...currentValues, value];

    setCommunicationStyle((prev) => ({ ...prev, [field]: newValues }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const accessToken = await getAccessTokenSilently();
      await updatePersona(
        digitalLegacy.personaId,
        { communicationStyle },
        accessToken
      );
      onSave();
      onClose();
    } catch (error) {
      console.error('Failed to update communication style:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={() => onClose()}>
          &times;
        </button>
        <h3>Edit Communication Style</h3>
        <p>
          Define how your persona speaks and interacts. You can select multiple
          options.
        </p>

        <div className={styles.formGroup}>
          <label>Pacing</label>
          <div className={styles.checkboxGrid}>
            {PACING_OPTIONS.map((opt) => (
              <label key={opt.value} className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className={styles.checkboxInput}
                  checked={(communicationStyle.pacing || []).includes(
                    opt.value
                  )}
                  onChange={() => handleCheckboxChange('pacing', opt.value)}
                />
                <span className={styles.checkboxControl}></span>
                {opt.label}
              </label>
            ))}
          </div>
        </div>

        <div className={styles.formGroup}>
          <label>Humor Style</label>
          <div className={styles.checkboxGrid}>
            {HUMOR_OPTIONS.map((opt) => (
              <label key={opt.value} className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className={styles.checkboxInput}
                  checked={(communicationStyle.humorStyle || []).includes(
                    opt.value
                  )}
                  onChange={() => handleCheckboxChange('humorStyle', opt.value)}
                />
                <span className={styles.checkboxControl}></span>
                {opt.label}
              </label>
            ))}
          </div>
        </div>

        <div className={styles.modalActions}>
          <button onClick={onClose} className="action-button secondary">
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="action-button primary"
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationStyleModal;
